import React, { useContext } from 'react';
import { object } from 'prop-types';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import SafePureComponentWrapper from '../shared/SafePureComponent';
import SeoScript from './SeoScript';
import { shouldFormatFaq, formatFAQ } from './formatFaq';
import { shouldFormatSeo, formatSeo } from './formatSeo';
import { formatBreadcrumbs } from './formatBreadcrumbs';

const Seo = ({ seo, faq }, { general, pathfinderWrapper, requestContext }) => {
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    return (
        <>
            <SeoScript scriptContent={formatBreadcrumbs({ general, pathfinderWrapper, locale, requestContext })}/>
            {shouldFormatSeo(seo) && <SeoScript scriptContent={formatSeo(seo)}/>}
            {shouldFormatFaq(faq) && <SeoScript scriptContent={formatFAQ(faq)}/>}
        </>
    );
};

Seo.propTypes = {
    faq: object,
    seo: object
};

Seo.contextTypes = {
    general: object,
    pathfinderWrapper: object,
    requestContext: object
};

export { Seo };
export default SafePureComponentWrapper(Seo);

